import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { useAuth } from '@/context/AuthContext';
import useScrollToTop from '@/hooks/useScrollToTop';

export default function Layout() {
  const { user } = useAuth();
  useScrollToTop();
  
  return (
    <div className="min-h-screen flex flex-col">
      {user && (
        <div className="sticky top-0 z-50">
          <Navbar />
        </div>
      )}
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}